import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { FormFlowFieldTypes } from "../Constants/FormFlowFieldTypes";
import { SimpleFormFlowField } from "../Models/SimpleFormFlowField";
import { Field } from "../Tenant/Applications/Airsweb/Models";
 
@Injectable({
    providedIn: 'root'
})
export class FormFlowService {
    constructor(private http: HttpClient) {
    }

    private apiFormFlowUrl = "/api/formflow";

    getFieldsOfType(tenantId: string, moduleId: string, version: number, fieldType: FormFlowFieldTypes): Observable<SimpleFormFlowField[]> {
        return this
            .http
            .get<SimpleFormFlowField[]>(`${this.apiFormFlowUrl}/fields/${fieldType}/${tenantId}/${moduleId}/${version}/`);
    }

    getFieldsOnMulti(tenantId: string, moduleId: string, version: number, multiPropertyName: string): Observable<Field[]> {
        return this
            .http
            .get<Field[]>(`${this.apiFormFlowUrl}/fields/${tenantId}/${moduleId}/${version}/onmulti/${multiPropertyName}/`);
    }

    getFieldsOfTypeMulti(tenantId: string, moduleId: string, version: number): any {
        return this
            .http
            .get<any>(`${this.apiFormFlowUrl}/fields/${tenantId}/${moduleId}/${version}`);
    }

    getCalculationTypes(): Observable<any[]> {
        return this
            .http
            .get<any[]>(`${this.apiFormFlowUrl}/calculationtypes`);
    }

    getParentFields(tenantId: string, moduleId: string, version: number, stepId: string): Observable<SimpleFormFlowField[]> {
        return this
            .http
            .get<SimpleFormFlowField[]>(`${this.apiFormFlowUrl}/fields/${tenantId}/${moduleId}/${version}/${stepId}`);
    }

    IsFieldLinkedAnotherOfType(parentPropertyName: string, tenantId: string, moduleId: string, version: number, fieldType: string): Observable<boolean> {
        return this
            .http
            .get<boolean>(`${this.apiFormFlowUrl}/fields/${parentPropertyName}/${tenantId}/${moduleId}/${version}/is-linked?fieldType=${fieldType}`);
    }

    getAllFieldsForModuleLatestVersion(tenantId: string, moduleId: string): Observable<SimpleFormFlowField[]> {
        return this
            .http
            .get<SimpleFormFlowField[]>(`${this.apiFormFlowUrl}/fields/${tenantId}/${moduleId}?include_multis=false`);
    }
}
